
import { Vue } from 'vue-class-component';

export default class BackLines extends Vue {

}
